/** Notas de entrada cuja trava de edição do vínculo deve ser consultada numa chamada. */
export class NotaFiscalEntradaEdicoesVinculoRequest {
  idsNFeEntrada: number[] = [];
}
